import "./AIMessage.css";
import { DeterminedPersonas } from "./DeterminedPersonas";
import { TypeWriter } from "./TypeWriter";

type StatusMessageProps = {
  message: string;
  personaIds?: string[];
  data?: any;
  success: boolean;
};

export const StatusMessage = ({
  message,
  personaIds,
  data,
  success,
}: StatusMessageProps) => {
  return (
    <div className="agent-chat-status-message">
      <div className="agent-chat-status-content">
        <div className="agent-chat-status-icon">
          {success ? (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="8" fill="#e8f5e9" />
              <path
                d="M12 5L6.5 10.5L4 8"
                stroke="#4caf50"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="8" r="8" fill="#fff3e0" />
              <path
                d="M8 4v4M8 10h.01"
                stroke="#ff9800"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
        <div className="agent-chat-status-text">
          <TypeWriter
            text={message}
            speed={25}
            className="agent-chat-status-typewriter"
          />
        </div>
      </div>
      {personaIds && personaIds.length > 0 && (
        <div className="agent-chat-status-personas">
          <DeterminedPersonas personaIds={personaIds} />
        </div>
      )}
    </div>
  );
};
